// extracted by mini-css-extract-plugin
export default {"appSelectedIcon":"AppSelectedIcon_appSelectedIcon__B-vol","isCenter":"AppSelectedIcon_isCenter__FP7t8"};